import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { fetchOpportunityInfo } from '../../actions/opportunityActions'
import { httpVerbConstants } from '../../constants/actionTypes'
import { fetchOpportunityInfo as consultantFetchOpportunityInfo } from '../../actions/consultantOpportunityActions'
import MainNav from 'application/components/navigation/mainNav'
import { logout } from '../../actions/authenticationActions'
import { msalAppRS, msalAppMX } from '../../utils/authConfig'
import { updateAccount } from '../../actions/updateActions'
import { checkConsultant } from '../../helpers'
import globals from 'application/constants/globals'

const CustomNavbar = ({
  accessToken,
  consultant,
  customer,
  isAuthenticated,
  opportunityId,
  dispatch,
  applicationRoles,
  isGov,
}) => {
  let headers = { accessToken: accessToken }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      if (customer && customer.id) {
        //do nothing
      } else {
        if (checkConsultant()) {
          dispatch(
            consultantFetchOpportunityInfo(
              opportunityId,
              headers,
              httpVerbConstants.HTTP_GET
            )
          )
        } else {
          dispatch(fetchOpportunityInfo(opportunityId))
        }
      }
    } else {
      if (checkConsultant()) {
        let msal = globals.isBrandMX ? msalAppMX : msalAppRS
        window.localStorage.clear()
        msal.logout()
        this.props.dispatch(updateAccount(null))
        window.location.href = '/consultant/login'
      } else {
        dispatch(logout())
        window.location.href = '/login'
      }
    }
  }, [])
  return (
    <MainNav
      applicationRoles={applicationRoles}
      customer={customer}
      consultant={consultant}
      isGov={isGov}
    />
  )
}

function mapStateToProps(state) {
  const { consultant, user: customer } = state
  const applicationRoles = state.applicationRoles
  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = state.authentication.opportunityId
  const accessToken = state.auth.accessToken
  const isGov = state.user.isGov

  return {
    accessToken,
    consultant,
    customer,
    isAuthenticated,
    opportunityId,
    applicationRoles,
    isGov,
  }
}

export default connect(mapStateToProps)(CustomNavbar)
